/**
 *
 * @component 用户中心/我的消息/互动消息/管家消息
 *
 **/

import { Pagination, Modal, message } from 'antd';
import dayjs from 'dayjs';
import { useLayoutEffect } from 'react';
import React, { forwardRef, useImperativeHandle } from 'react';
import {
    manegerMsgList,
    manegerMsgDetail,
    markAllRead,
    deleteMsg,
    // repealMsg,
} from '@/api/personCenter/message';
import BaseListWrap from '&/components/BaseListWrap';
import BaseDrawer from '&/components/BaseDrawer';
import useStoreState from '&/utils/customHooks/useStoreState';
import './StewardMsg.scss';

const StewardMsg = forwardRef((props, ref) => {
    const { dop = 1 } = props,
        IS_SEND = dop === 1,
        IS_RECEIVE = dop === 2;

    const [param, setParam] = useState({ dop, page: 1, pageNum: 10 });

    const onPageChange = (page, pageNum) => {
        setParam(pre => ({ ...pre, page, pageNum }));
    };

    const [msgList, setMsgList] = useState([]),
        [total, setTotal] = useState(0),
        [loading, setLoading] = useState(false);

    function qeuryList() {
        setLoading(true);
        manegerMsgList(param)
            .then(({ data }) => {
                setMsgList(data.list);
                setTotal(+data.count);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        qeuryList();
    }, [param]);

    const markAsRead = () => {
        markAllRead().then(() => {
            setMsgList(prev => {
                const next = [...prev];
                next.forEach(el => {
                    el.message.forEach(cel => {
                        cel.status = '1';
                    });
                });
                return next;
            });
        });
    };

    useImperativeHandle(ref, () => ({ markAsRead, refresh: qeuryList }));

    const updateStatus = (index, cIndex, status) => {
        setMsgList(prev => {
            const next = [...prev];
            next[index].message[cIndex].status = status;
            return next;
        });
    };

    const delMsg = (e, item) => {
        e.stopPropagation();
        const modal = Modal.confirm({
            content: intl.get('message.steward.deleteWarning'),
            okText: intl.get('base.delete'),
            cancelText: intl.get('base.cancel'),
            okButtonProps: { loading: false },
            centered: true,
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    const { msg } = await deleteMsg({ userMessageId: item.id });
                    message.success(msg);
                    qeuryList();
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    };

    // 撤回
    /* const onRepeal = (e, item, index, cIndex) => {
        e.stopPropagation();
        repealMsg({ messageId: item.id }).then(() => {
            updateStatus(index, cIndex, '2');
        });
    }; */

    const [visible, setVisible] = useState(false);

    const onClose = () => {
        setVisible(false);
    };

    const [detailData, setDetailData] = useState({});

    const showDetail = (msgItem, index, cIndex) => {
        setDetailData(msgItem);
        setVisible(true);
        manegerMsgDetail({ dop, messageId: msgItem.id }).then(({ data }) => {
            setDetailData(prev => ({ ...prev, ...data.detail }));
            updateStatus(index, cIndex, '1');
        });
    };
    const { organization = {} } = useStoreState('appStore');

    const disabled =
        organization.example === 0 && organization.roleFlag !== 'admin';

    const { createDate } = detailData;

    const [isViewAll, setViewAll] = useState(false); // 更多筛选按钮
    const [hasMore, setHasMore] = useState(false); // 是否有隐藏行
    const usersRef = useRef();

    //   隐藏行多出来的内容
    useLayoutEffect(() => {
        visible && detailData.userList?.length && measureRowsHeight();
    }, [detailData.userList, visible]);

    useEffect(() => {
        if (visible) return;
        setViewAll(false);
        setHasMore(false);
        setDetailData({});
    }, [visible]);

    function measureRowsHeight() {
        const height = usersRef.current.clientHeight;
        setHasMore(height > 23);
    }

    const detailDrawer = (
        <BaseDrawer
            visible={visible}
            title={intl.get('message.steward.notification')}
            bodyStyle={{
                padding: '1.875rem 3.75rem',
            }}
            width="47.5rem"
            destroyOnClose
            className="msg-detail"
            onClose={onClose}>
            {IS_SEND ? (
                <>
                    <section className="item-block">
                        <span className="msg-detail-label">
                            {intl.get('message.steward.title')}
                        </span>
                        {detailData.title}
                    </section>
                    <section className="item-block item-block2">
                        <span className="msg-detail-label">
                            {intl.get('message.steward.send')}
                        </span>
                        <div
                            className={`send-users${
                                hasMore && !isViewAll ? ' is--hidden' : ''
                            }`}
                            ref={usersRef}>
                            <div className="send-users-content">
                                {detailData.userList
                                    ?.map(el => el.username)
                                    .join('、')}
                            </div>
                        </div>
                        {hasMore && (
                            <div
                                className="view-more pointer"
                                onClick={() => setViewAll(p => !p)}>
                                {isViewAll ? '收起' : '更多'}
                                <i
                                    className={`${
                                        isViewAll
                                            ? 'icon-arrow-up'
                                            : 'icon-arrow-down'
                                    } outlined`}></i>
                            </div>
                        )}
                    </section>
                    <section className="item-block">
                        <span className="msg-detail-label">
                            {intl.get('message.steward.sendTime')}
                        </span>

                        {createDate?.length === 10
                            ? dayjs(createDate).format('YYYY-MM-DD HH:mm')
                            : createDate}
                    </section>
                    <section className="item-block">
                        <span className="msg-detail-label">
                            {intl.get('message.steward.sendContent')}
                        </span>
                    </section>
                    <article className="item-article">
                        {detailData.content}
                    </article>
                </>
            ) : (
                <>
                    <header className="msg-title">{detailData.title}</header>
                    <div className="msg-time">
                        {createDate?.length === 10
                            ? dayjs(createDate).format('YYYY-MM-DD HH:mm')
                            : createDate}
                    </div>
                    <article className="item-article">
                        {detailData.content}
                    </article>
                </>
            )}
        </BaseDrawer>
    );

    return (
        <BaseListWrap isLoading={loading} isEmpty={!!total}>
            {msgList.map((e, index) => (
                <React.Fragment key={e.day}>
                    <div className="date-title">{e.day}</div>
                    {e.message.map((child, cIndex) => {
                        const { status } = child;
                        // 已撤回
                        const isRevocation = IS_SEND && status === '2';
                        return (
                            <section
                                className="msg-item"
                                key={child.id}
                                onClick={() =>
                                    showDetail(child, index, cIndex)
                                }>
                                {IS_RECEIVE ? (
                                    <i
                                        className={`icon-bell filled read-icon${
                                            status === '2' ? ' unred' : ''
                                        }`}
                                    />
                                ) : (
                                    <i className="icon-bell outlined msg-icon" />
                                )}

                                <div
                                    className={`message-main${
                                        isRevocation ? ' is--revocation' : ''
                                    }`}>
                                    <div className="message-content">
                                        <div className="message-tag">
                                            {intl.get(
                                                'message.steward.recalled'
                                            )}
                                        </div>
                                        {child.title}
                                    </div>
                                    <div className="message-aside">
                                        <div className="time">
                                            {child.createTime}
                                        </div>
                                        {
                                            IS_RECEIVE && (
                                                <i
                                                    className={`text-btn filled icon-trash${
                                                        disabled
                                                            ? ' type--disabled'
                                                            : ''
                                                    }`}
                                                    onClick={e =>
                                                        !disabled &&
                                                        delMsg(e, child)
                                                    }
                                                />
                                            ) /* : (
                                            status === '1' && (
                                                <Button
                                                    size="small"
                                                    onClick={e =>
                                                        onRepeal(
                                                            e,
                                                            child,
                                                            index,
                                                            cIndex
                                                        )
                                                    }>
                                                    {intl.get(
                                                        'message.steward.recall'
                                                    )}
                                                </Button>
                                            )
                                        ) */
                                        }
                                    </div>
                                </div>
                            </section>
                        );
                    })}
                </React.Fragment>
            ))}
            <Pagination
                size="small"
                current={param.page}
                onChange={onPageChange}
                pageSize={param.pageNum}
                total={total}
                showSizeChanger={true}
                showTotal={total => intl.get('base.total', { total })}
            />
            {detailDrawer}
        </BaseListWrap>
    );
});
export default StewardMsg;
